<template>
  <DividerSeparator class="wide">
    <Loader />
    <div slot="title">Loading Data</div>
  </DividerSeparator>
</template>

<script>
import Loader from "vue-spinner/src/BounceLoader";
export default {
  name: "form-transfer-init",
  components: { Loader }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
